module.exports = __webpack_public_path__ + "static/media/2010 - 11 Thomas Chiu-min.ce6d3246.jpg";